import React from "react";
import PropTypes from "prop-types";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  bold: {
    fontWeight: "bold",
  },
  section: {
    marginBottom: 10,
  },
  title: {
    fontSize: 10,
    marginBottom: 10,
    fontWeight: "bold",
  },
});

const ReporteResizePdf = ({ data }) => {
  const mapDays = (days) => {
    const dayMap = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miércoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sábado",
    };
    if (typeof days === "string") {
      days = days.replace(/[{}]/g, "").split(",").map(Number);
    }
    if (!Array.isArray(days) || days.length === 0) {
      return "No disponible";
    }
    return days.map((day) => dayMap[day] || "Día desconocido").join(", ");
  };

  const hasData = data?.rows?.length > 0;

  return (
    <View>
      {" "}
      <Text style={styles.title}>Informe de Resize:</Text>
      {hasData ? (
        data.rows.map((row, index) => (
          <View key={index} style={styles.section}>
            <Text>
              <Text style={styles.bold}>Días: </Text>
              {mapDays(row.dias)}
            </Text>
            <Text>
              <Text style={styles.bold}>Hora Base: </Text>
              {row.hora_base} (Se aumentan y se normalizan los recursos, reinicio de servidor)
            </Text>
            <Text>
              <Text style={styles.bold}>Hora Resize: </Text>
              {row.hora_resize} (Se disminuyen los recursos, reinicio de servidor)
            </Text>
          </View>
        ))
      ) : (
        <Text style={styles.bold}>Esta instancia no tiene proceso de Resize.</Text>
      )}
    </View>
  );
};

ReporteResizePdf.propTypes = {
  data: PropTypes.shape({
    rowCount: PropTypes.number,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        cuenta: PropTypes.string,
        dias: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.string]),
        hora_base: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hora_resize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        instance_id: PropTypes.string,
        instance_name: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default ReporteResizePdf;
